const availableLanguages = [
	{
		languageID: "CODELANG002",
		languageName: "java",
		active: true,
		createdAt: "2023-05-30T13:12:56.037000Z",
		updatedAt: "2023-05-30T13:12:56.037000Z",
		name: "Java",
		title: "Java Hello World",
		version: "11",
		description: null,
		extension: "java",
		languageType: "programming",
		language: "java",
		properties: {
			name: "Main.java",
			content:
				'import java.util.*;\n\npublic class Main {\n    public static void main(String[] args) {\n      System.out.println("Hello, World!");\n  }\n}',
		},
	},
	{
		languageID: "CODELANG001",
		languageName: "python",
		active: true,
		createdAt: "2023-05-30T13:09:01.261000Z",
		updatedAt: "2023-05-30T13:09:01.261000Z",
		name: "Python",
		title: "Python Hello World",
		version: "3.6",
		description: null,
		extension: "py",
		languageType: "programming",
		language: "python",
		properties: {
			name: "main.py",
			content: 'print("Hello, World!")',
		},
	},
	{
		languageID: "CODELANG004",
		languageName: "c",
		active: true,
		createdAt: "2023-05-30T13:13:05.422000Z",
		updatedAt: "2023-05-30T13:13:05.422000Z",
		name: "C",
		title: "C Language Hello World",
		version: "latest",
		description: null,
		extension: "c",
		languageType: "programming",
		language: "c",
		properties: {
			name: "Main.c",
			content:
				'#include <stdio.h>\nint main()\n{\n    printf("Hello, World!");\n}',
		},
	},
	{
		languageID: "CODELANG005",
		languageName: "c++",
		active: true,
		createdAt: "2023-05-30T13:13:07.600000Z",
		updatedAt: "2023-05-30T13:13:07.600000Z",
		name: "C++",
		title: "C++ Hello World",
		version: "latest",
		description: null,
		extension: "cpp",
		languageType: "programming",
		language: "cpp",
		properties: {
			name: "Main.cpp",
			content:
				'#include <iostream>\nusing namespace std;\n\nint main() \n{\n    cout << "Hello, World!";\n    return 0;\n}',
		},
	},
	{
		languageID: "CODELANG003",
		languageName: "javascript",
		active: true,
		createdAt: "2023-05-30T13:12:59.689000Z",
		updatedAt: "2023-05-30T13:12:59.689000Z",
		name: "JavaScript",
		title: "JavaScript Hello World",
		version: "ES6",
		description: null,
		extension: "js",
		languageType: "programming",
		language: "javascript",
		properties: {
			name: "index.js",
			content: 'console.log("Hello, World!");',
		},
	},
];
export default availableLanguages;

// {
//   "type": "Success",
//   "data": [
//       {
//           "languageID": "CODELANG002",
//           "languageName": "python",
//           "active": true,
//           "createdAt": "2023-05-30T13:09:01.261000Z",
//           "updatedAt": "2023-05-30T13:09:01.261000Z"
//       },
//       {
//           "languageID": "CODELANG003",
//           "languageName": "java",
//           "active": true,
//           "createdAt": "2023-05-30T13:12:56.037000Z",
//           "updatedAt": "2023-05-30T13:12:56.037000Z"
//       },
//       {
//           "languageID": "CODELANG004",
//           "languageName": "javascript",
//           "active": true,
//           "createdAt": "2023-05-30T13:12:59.689000Z",
//           "updatedAt": "2023-05-30T13:12:59.689000Z"
//       },
//       {
//           "languageID": "CODELANG005",
//           "languageName": "c",
//           "active": true,
//           "createdAt": "2023-05-30T13:13:05.422000Z",
//           "updatedAt": "2023-05-30T13:13:05.422000Z"
//       },
//       {
//           "languageID": "CODELANG006",
//           "languageName": "c++",
//           "active": true,
//           "createdAt": "2023-05-30T13:13:07.600000Z",
//           "updatedAt": "2023-05-30T13:13:07.600000Z"
//       }
//   ]
// }
